import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getMessageFromError } from "../../../shared/welda/services/utilsService";
import errorHandling from "../errorHandling";
import pricetagsService from "./pricetagsService";

const initialState = {
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: "",
};

export const createPricetaglink = createAsyncThunk(
  "pricetags/createlink",
  async (formData, thunkAPI) => {
    try {
      return await pricetagsService.createPricetaglink(formData);
    } catch (error) {
      const message = getMessageFromError(error);
      error.toString();
      errorHandling(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const pricetagsSlice = createSlice({
  name: "pricetags",
  initialState,
  reducers: {
    reset: (state) => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(createPricetaglink.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createPricetaglink.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.message = action.payload.message;
      })
      .addCase(createPricetaglink.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      });
  },
});

export const { reset } = pricetagsSlice.actions;
export default pricetagsSlice.reducer;
